import { TraceableProcess, TrackingEvent } from '@services/analytics/model';

export class ListingShared implements TrackingEvent {
  public readonly category = TraceableProcess.LISTING_DETAILS;
  public readonly action = 'ListingShared';

  constructor(public readonly estateLegalId: string, public readonly socialNetwork: string) {}
}
